module.exports = __webpack_public_path__ + "static/media/internal-migration.e36ebe03.svg";